$(document).ready(function () {
    -1 != navigator.userAgent.indexOf("Mac OS X") && document.querySelector("body").classList.add("mac");
    $('a[href="#"]').click(function (event) {
        event.preventDefault();
    });
    var e = document.querySelector(".responsive-image"),
        t = document.querySelector(".responsive-image.has-mobile"),
        o = document.querySelectorAll(".responsive-image.has-mobile .desktop"),
        r = document.querySelectorAll(".responsive-image.has-mobile .mobile");
    const a = document.querySelector("body").getAttribute("data-money-format");

    function lockHorizontalSwiperTouch() {
        document.querySelectorAll(".swiper").forEach((e) => {
            if (e.dataset.touchFixed) return;
            if (e.classList.contains("swiper-vertical") || e.classList.contains("no-swipe-lock")) return;

            e.dataset.touchFixed = "true";

            let t = 0,
                o = 0,
                r = "",
                a = !1;

            e.addEventListener(
                "touchstart",
                function (e) {
                    if (!e.touches || !e.touches.length) return;

                    t = e.touches[0].clientX;
                    o = e.touches[0].clientY;
                    r = "";
                    a = !1;
                },
                { passive: !0 }
            );

            e.addEventListener(
                "touchmove",
                function (e) {
                    if (!e.touches || !e.touches.length) return;

                    let n = e.touches[0].clientX - t,
                        c = e.touches[0].clientY - o,
                        s = Math.abs(n),
                        i = Math.abs(c);

                    if (!r) {
                        if (s < 8 && i < 8) return;

                        if (s > i * 1.1) {
                            r = "horizontal";
                        } else if (i > s) {
                            r = "vertical";
                        } else {
                            return;
                        }
                    }

                    if ("horizontal" === r) {
                        if (!a) {
                            a = !0;
                        }

                        e.preventDefault();
                    }
                },
                { passive: !1 }
            );

            e.addEventListener(
                "touchend",
                function () {
                    r = "";
                    a = !1;
                },
                { passive: !0 }
            );

            e.addEventListener(
                "touchcancel",
                function () {
                    r = "";
                    a = !1;
                },
                { passive: !0 }
            );
        });
    }

    lockHorizontalSwiperTouch();
    document.addEventListener("shopify:section:load", lockHorizontalSwiperTouch);
    document.addEventListener("shopify:section:reorder", lockHorizontalSwiperTouch);

    (function () {
        if (typeof window.Swiper === "undefined") return;
        if (window.Swiper._arrowsHideReady) return;

        var OriginalSwiper = window.Swiper;

        function getArrowElement(arrow, container, fallbackSelector) {
            if (!arrow && container) {
                return container.closest(".global-slider-wrapper, .products-slider-wrapper, .product-upsell-wrapper, .slider-home")?.querySelector(fallbackSelector);
            }

            if (typeof arrow === "string") {
                return document.querySelector(arrow);
            }

            if (arrow instanceof Element) {
                return arrow;
            }

            return null;
        }

        window.Swiper = function (el, config) {
            config = config || {};

            var container = typeof el === "string" ? document.querySelector(el) : el;
            var navigation = config.navigation || {};

            var prevArrow = getArrowElement(
                navigation.prevEl,
                container,
                ".products-slider-prev, .slider-home__arrow-prev"
            );

            var nextArrow = getArrowElement(
                navigation.nextEl,
                container,
                ".products-slider-next, .slider-home__arrow-next"
            );

            var originalInit = config.on && config.on.init;

            config.on = config.on || {};

            config.on.init = function () {
                if (typeof originalInit === "function") {
                    originalInit.call(this);
                }

                if (prevArrow) prevArrow.classList.remove("hide");
                if (nextArrow) nextArrow.classList.remove("hide");
            };

            return new OriginalSwiper(el, config);
        };

        window.Swiper.prototype = OriginalSwiper.prototype;
        window.Swiper._arrowsHideReady = true;
    })();

    function initSliderHome() {
        var sliders = document.querySelectorAll(".slider-home");

        if (!sliders.length || typeof Swiper === "undefined") return;

        sliders.forEach(function (slider) {
            if (slider.classList.contains("swiper-initialized")) return;

            var totalSlides = slider.querySelectorAll(".swiper-slide").length;
            var counterCurrent = slider.querySelector(".slider-home__counter-current");
            var counterTotal = slider.querySelector(".slider-home__counter-total");
            var prevArrow = slider.querySelector(".slider-home__arrow-prev");
            var nextArrow = slider.querySelector(".slider-home__arrow-next");
            var pagination = slider.querySelector(".slider-home__pagination");

            if (counterTotal) {
                counterTotal.textContent = totalSlides;
            }

            if (totalSlides <= 1) {
                slider.classList.add("slider-home--single");
                return;
            }
            
            var isDesktop = window.innerWidth > 992;

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 350,
                loop: false,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },

                navigation: isDesktop
                    ? {
                        prevEl: prevArrow,
                        nextEl: nextArrow,
                        disabledClass: "is-disabled"
                    }
                    : false,

                pagination: {
                    el: pagination,
                    clickable: true,
                    bulletClass: "slider-home__dot",
                    bulletActiveClass: "is-active"
                },

                on: {
                    init: function () {
                        if (counterCurrent) {
                            counterCurrent.textContent = this.realIndex + 1;
                        }
                    },
                    slideChange: function () {
                        if (counterCurrent) {
                            counterCurrent.textContent = this.realIndex + 1;
                        }
                    }
                }
            });
        });

        if (typeof lockHorizontalSwiperTouch === "function") {
            lockHorizontalSwiperTouch();
        }
    }

    function initCollectionProductsSlider() {
        var sliders = document.querySelectorAll(".swiper-collection-products");

        if (!sliders.length || typeof Swiper === "undefined") return;

        sliders.forEach(function (slider) {
            if (slider.classList.contains("swiper-initialized")) return;

            var wrapper = slider.closest(".products-slider-wrapper");
            if (!wrapper) return;

            var totalSlides = slider.querySelectorAll(".swiper-slide").length;
            var prevArrow = wrapper.querySelector(".products-slider-prev");
            var nextArrow = wrapper.querySelector(".products-slider-next");
            var pagination = wrapper.querySelector(".products-slider-pagination");

            if (totalSlides <= 2) {
                wrapper.classList.add("global-slider-wrapper--single");
            }

            new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 12,
                speed: 350,
                loop: false,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                grabCursor: true,
                resistanceRatio: 0.85,
                touchRatio: 1.2,
                shortSwipes: true,
                longSwipesRatio: 0.25,

                pagination: {
                    el: pagination,
                    clickable: true,
                    bulletClass: "global-slider-dot",
                    bulletActiveClass: "is-active"
                },

                navigation: {
                    prevEl: prevArrow,
                    nextEl: nextArrow,
                    disabledClass: "is-disabled"
                },

                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 12
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 16
                    },
                    993: {
                        slidesPerView: 5,
                        spaceBetween: 16
                    }
                }
            });
        });

        if (typeof lockHorizontalSwiperTouch === "function") {
            lockHorizontalSwiperTouch();
        }
    }

    function initCategorySlider() {
        var sliders = document.querySelectorAll(".category-swiper");

        if (!sliders.length || typeof Swiper === "undefined") return;

        sliders.forEach(function (slider) {
            if (slider.classList.contains("swiper-initialized")) return;

            var wrapper = slider.closest(".category-slider-wrapper");
            if (!wrapper) return;

            var totalSlides = slider.querySelectorAll(".swiper-slide").length;
            var prevArrow = wrapper.querySelector(".products-slider-prev");
            var nextArrow = wrapper.querySelector(".products-slider-next");
            var pagination = wrapper.querySelector(".products-slider-pagination");

            if (totalSlides <= 2) {
                wrapper.classList.add("global-slider-wrapper--single");
            }

            new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 2,
                speed: 350,
                loop: false,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                grabCursor: true,
                resistanceRatio: 0.85,
                touchRatio: 1.2,
                shortSwipes: true,
                longSwipesRatio: 0.25,

                pagination: {
                    el: pagination,
                    clickable: true,
                    bulletClass: "global-slider-dot",
                    bulletActiveClass: "is-active"
                },

                navigation: {
                    prevEl: prevArrow,
                    nextEl: nextArrow,
                    disabledClass: "is-disabled"
                },

                breakpoints: {
                    0: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    578: {
                        slidesPerView: 4,
                        spaceBetween: 10
                    },
                    768: {
                        slidesPerView: 5,
                        spaceBetween: 10
                    },
                    992: {
                        slidesPerView: 7,
                        spaceBetween: 10
                    },
                    1250: {
                        slidesPerView: 10
                    }
                }
            });
        });

        if (typeof lockHorizontalSwiperTouch === "function") {
            lockHorizontalSwiperTouch();
        }
    }

    function initCategoryModalSlider() {
        var sliders = document.querySelectorAll("#filters .category-modal-swiper");

        if (!sliders.length || typeof Swiper === "undefined") return;

        sliders.forEach(function (slider) {
            var wrapper = slider.closest(".global-slider-wrapper");
            if (!wrapper) return;

            var prevArrow = wrapper.querySelector(".products-slider-prev");
            var nextArrow = wrapper.querySelector(".products-slider-next");
            var pagination = wrapper.querySelector(".products-slider-pagination");

            if (slider.swiper) {
                slider.swiper.destroy(true, true);
            }

            new Swiper(slider, {
                slidesPerView: 3,
                spaceBetween: 10,
                speed: 350,
                loop: false,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                grabCursor: true,

                pagination: {
                    el: pagination,
                    clickable: true,
                    bulletClass: "global-slider-dot",
                    bulletActiveClass: "is-active"
                },

                navigation: {
                    prevEl: prevArrow,
                    nextEl: nextArrow,
                    disabledClass: "is-disabled"
                },

                breakpoints: {
                    0: {
                        slidesPerView: 3,
                        spaceBetween: 0
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 0
                    }
                }
            });
        });
    }

    function initDynamicProductRecommendations() {
        var blocks = document.querySelectorAll(".product-recommendations[data-url]");

        if (!blocks.length) return;

        blocks.forEach(function (block) {
            if (block.dataset.recommendationsLoaded === "true") return;

            var section = block.closest(".product-recommendations-section");

            fetch(block.dataset.url)
                .then(function (response) {
                    return response.text();
                })
                .then(function (html) {
                    var temp = document.createElement("div");
                    temp.innerHTML = html;

                    var recommendations = temp.querySelector(".product-recommendations");
                    var slides = temp.querySelectorAll(".swiper-slide");

                    if (!recommendations || slides.length === 0) return;

                    block.innerHTML = recommendations.innerHTML;
                    block.dataset.recommendationsLoaded = "true";

                    if (section) {
                        section.classList.remove("hide");
                    }

                    if (typeof initCollectionProductsSlider === "function") {
                        initCollectionProductsSlider();
                    }

                    if (typeof window.initFavoritesSystem === "function") {
                        window.initFavoritesSystem();
                    }
                })
                .catch(function (error) {
                    console.error("Erro ao carregar recomendações:", error);
                });
        });
    }

    function initTopHeaderSlider() {
        var sliders = document.querySelectorAll(".top-header-swiper");

        if (!sliders.length || typeof Swiper === "undefined") return;

        sliders.forEach(function (slider) {
            if (slider.classList.contains("swiper-initialized")) return;

            var wrapper = slider.querySelector(".swiper-wrapper");
            if (!wrapper) return;

            var originalSlides = Array.from(wrapper.children);

            if (!originalSlides.length) return;

            var sliderStyle = slider.dataset.sliderStyle || "infinite";
            var isInfinite = sliderStyle === "infinite";

            if (isInfinite) {
                while (wrapper.scrollWidth < window.innerWidth * 2.5) {
                    originalSlides.forEach(function (slide) {
                        wrapper.appendChild(slide.cloneNode(true));
                    });
                }
            }

            var swiperOptions = {
                slidesPerView: isInfinite ? "auto" : 1,
                spaceBetween: 0,
                loop: true,
                speed: isInfinite ? 10000 : 600,
                allowTouchMove: !isInfinite,
                watchSlidesProgress: true,

                autoplay: {
                    delay: isInfinite ? 1 : 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: !isInfinite
                }
            };

            if (!isInfinite) {
                swiperOptions.effect = "fade";

                swiperOptions.fadeEffect = {
                    crossFade: true
                };

                swiperOptions.navigation = {
                    nextEl: slider.querySelector(".top-header-next"),
                    prevEl: slider.querySelector(".top-header-prev")
                };

                swiperOptions.on = {
                    init: function () {
                        slider.classList.add("top-header-swiper-ready");
                    }
                };
            }

            new Swiper(slider, swiperOptions);
        });
    }

    function initProductUpsellSlider() {
        var sliders = document.querySelectorAll(".product-upsell.swiper");

        if (!sliders.length || typeof Swiper === "undefined") return;

        sliders.forEach(function (slider) {
            if (slider.classList.contains("swiper-initialized")) return;

            var wrapper = slider.closest(".product-upsell-wrapper");
            if (!wrapper) return;

            var totalSlides = slider.querySelectorAll(".swiper-slide").length;
            var prevArrow = wrapper.querySelector(".products-slider-prev");
            var nextArrow = wrapper.querySelector(".products-slider-next");
            var pagination = wrapper.querySelector(".products-slider-pagination");

            if (totalSlides <= 2) {
                wrapper.classList.add("global-slider-wrapper--single");
            }

            new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 12,
                speed: 350,
                loop: false,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                grabCursor: true,
                resistanceRatio: 0.85,
                touchRatio: 1.2,
                shortSwipes: true,
                longSwipesRatio: 0.25,

                pagination: {
                    el: pagination,
                    clickable: true,
                    bulletClass: "global-slider-dot",
                    bulletActiveClass: "is-active"
                },

                navigation: {
                    prevEl: prevArrow,
                    nextEl: nextArrow,
                    disabledClass: "is-disabled"
                },

                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 5
                    },
                    578: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 10
                    },
                    1250: {
                        slidesPerView: 5,
                        spaceBetween: 10
                    }
                }
            });
        });

        if (typeof lockHorizontalSwiperTouch === "function") {
            lockHorizontalSwiperTouch();
        }
    }

    function updateResponsiveImages() {
        var isMobile = window.innerWidth <= 992;

        document.querySelectorAll(".responsive-image.has-mobile").forEach(function (wrapper) {
            wrapper.querySelectorAll(".desktop").forEach(function (desktop) {
                desktop.style.display = isMobile ? "none" : "";
            });

            wrapper.querySelectorAll(".mobile").forEach(function (mobile) {
                mobile.style.display = isMobile ? "" : "none";
            });
        });
    }
    
    initSliderHome();
    initCollectionProductsSlider();
    initCategorySlider();
    initDynamicProductRecommendations();
    initTopHeaderSlider();
    initProductUpsellSlider();
    updateResponsiveImages();

    window.addEventListener("resize", function () {
        initSliderHome();
        initCollectionProductsSlider();
        initCategorySlider();
        initDynamicProductRecommendations();
        initTopHeaderSlider();
        initProductUpsellSlider();
        updateResponsiveImages();
    });

    document.addEventListener("shopify:section:load", function () {
        initSliderHome();
        initCollectionProductsSlider();
        initCategorySlider();
        initDynamicProductRecommendations();
        initTopHeaderSlider();
        initProductUpsellSlider();
        
        if (typeof formatReviewNumbers === 'function') {
            formatReviewNumbers();
        }
    });

    document.addEventListener("shopify:section:reorder", function () {
        initSliderHome();
        initCollectionProductsSlider();
        initCategorySlider();
        initDynamicProductRecommendations();
        initTopHeaderSlider();
        initProductUpsellSlider();
    });

    document.querySelectorAll("[data-modal]").forEach((trigger) => {
        trigger.addEventListener("click", function (event) {
            event.preventDefault();

            const modalKey = this.dataset.modal;
            let modal = null;

            if (modalKey.startsWith("#") || modalKey.startsWith(".")) {
                modal = document.querySelector(modalKey);
            } else {
                modal = document.getElementById(modalKey);
            }

            if (!modal) {
                console.warn("Modal não encontrado para:", modalKey);
                return;
            }

            openModal(modal);
        });
    });

    if (document.querySelector("[tip]")) {
        $("[tip]")
            .hover(
                function () {
                    var e = $(this).attr("tip");
                    $(this).data("tipText", e);
                    $('<p class="tip"></p>').text(e).appendTo("body").fadeIn(0);
                },
                function () {
                    $(this).attr("tip", $(this).data("tipText"));
                    $(".tip").remove();
                }
            )
            .mousemove(function (e) {
                var t = e.pageX + 20,
                    o = e.pageY + 10;
                $(".tip").css({ top: o, left: t });
            });
    }

    if (document.querySelector(".quantity")) {
        if (Number(document.querySelector(".quantity .qty").value) > 1) {
            document.querySelector(".quantity button.minus").disabled = false;
        }

        document.querySelectorAll(".quantity button").forEach((e) => {
            e.addEventListener("click", () => {
                var t = e.parentElement.querySelector("input"),
                    o = Number(t.value),
                    isPlus = e.classList.contains("plus");

                if (isPlus) {
                    var a = o + 1;
                    t.value = a;
                    quantityAnimation("plus", a);
                    document.querySelector(".quantity button.minus").disabled = false;
                    document.querySelector("#product-quantity").value = a;
                } else if (o > 1) {
                    var a = o - 1;
                    t.value = a;
                    quantityAnimation("minus", o);

                    if (a < 2) {
                        document.querySelector(".quantity button.minus").disabled = true;
                    }

                    document.querySelector("#product-quantity").value = a;
                }
            });
        });
    }

    var searchButton = document.querySelector('.open-search-bar');
    var searchBar = document.querySelector('.search-bar-content');
    var searchOverlay = document.querySelector('.search-overlay');
    var header = document.querySelector('header');

    function openSearch(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (!searchBar) return;

        searchBar.classList.add('open');

        if (header) {
            header.classList.add('focus');
        }

        if (typeof V === 'function') {
            V();
        }

        var input = searchBar.querySelector('input[type="text"]');

        if (input) {
            input.focus();
        }
    }

    if (searchButton && searchBar) {
        searchButton.addEventListener('click', openSearch);

        searchButton.addEventListener('touchstart', function () {
            var input = searchBar.querySelector('input[type="text"]');

            if (input) {
                input.focus();
            }
        }, { passive: true });
    }

    if (searchOverlay) {
        searchOverlay.addEventListener('click', function () {
            closeSearch();
        });
    }

    if (document.querySelector('[data-selector-type="pack-image"]')) {
        // Seleciona todos os labels dentro do documento
        const labels = document.querySelectorAll('label');

        labels.forEach(label => {
            label.addEventListener('click', function() {
                // Seleciona o elemento que deverá receber ou perder a classe 'active'
                const packFreeProduct = document.querySelector('.pack-free-product');

                // Verifica se o label clicado tem a classe 'has-free-product'
                if (this.classList.contains('has-free-product')) {
                    // Adiciona a classe 'active' ao elemento 'pack-free-product'
                    if (packFreeProduct) {
                        packFreeProduct.classList.add('active');
                    }
                } else {
                    // Remove a classe 'active' do elemento 'pack-free-product'
                    if (packFreeProduct) {
                        packFreeProduct.classList.remove('active');
                    }
                }
            });
        });
    }

    function closeSearch() {
        if (searchBar) {
            searchBar.classList.remove('open');
        }

        if (header) {
            header.classList.remove('focus');
        }

        $(".search-results").removeClass("search-box");
        $(".search-results").empty();

        if (typeof W === 'function') {
            W(); // remove overlay
        }
    }

    function handleSearchOutsideClick(e) {
        if (!searchBar || !searchBar.classList.contains('open')) return;

        var isClickInsideSearch = e.target.closest('.search-bar-content');
        var isClickInsideResults = e.target.closest('.search-results');
        var isClickOnButton = e.target.closest('.open-search-bar');

        if (!isClickInsideSearch && !isClickInsideResults && !isClickOnButton) {
            closeSearch();
        }
    }

    document.addEventListener('mousedown', handleSearchOutsideClick);
    document.addEventListener('touchstart', handleSearchOutsideClick, { passive: true });
    
    if (document.querySelector("#direct-checkout")) {
      document.getElementById('direct-checkout').addEventListener('click', function() {
        var form = document.querySelector('.product-form');
        var formData = new FormData(form);
        formData.set('quantity', '1'); // Assegure-se de que a quantidade esteja sempre definida como 1 para compras diretas
      
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (response.ok) {
            window.location.href = '/checkout';
          } else {
            console.log('Houve um problema ao adicionar o produto ao carrinho.');
          }
        })
        .catch(error => {
          console.error('Erro ao processar a compra:', error);
        });
      });
    }
  
    if (document.querySelector("#timer")) {
        var n = getCookie("countDownHours"),
            c = getCookie("countDownMinutes"),
            s = getCookie("countDownSeconds");
        const e = 1e3,
            t = document.querySelector("#timer");
        var i = t.getAttribute("data-hours"),
            d = t.getAttribute("data-minutes"),
            l = t.getAttribute("data-seconds");
        n && (t.setAttribute("data-hours", n), t.setAttribute("data-minutes", c), t.setAttribute("data-seconds", s));
        let o = t.dataset.hours,
            r = t.dataset.minutes,
            a = t.dataset.seconds,
            u = (t.getAttribute("data-timer-end"), "data-timer-end");
        ("" != o && null != o && NaN != o) || (o = "0"), ("" != r && null != r && NaN != r) || (r = "0"), ("" != a && null != a && NaN != a) || (a = "0");
        let p = document.querySelector("span.time.hours"),
            m = document.querySelector("span.time.minutes"),
            h = document.querySelector("span.time.seconds"),
            y = 59,
            f = parseInt(a) > y ? y : parseInt(a),
            v = parseInt(r) > y ? y : parseInt(r),
            b = parseInt(o);
        (checkValue = (e) => (e < 10 ? "0" + e : e)),
            (p.textContent = checkValue(o)),
            (m.textContent = checkValue(r)),
            (h.textContent = checkValue(a)),
            (timer = (e, t, o) => ((f = parseInt(e)), (v = parseInt(t)), (b = parseInt(o)), f > 0 ? (f -= 1) : ((f = y), v > 0 ? (v -= 1) : ((v = y), b > 0 ? (b -= 1) : void 0)))),
            (finished = () => {
                y = 0;
                let e = t.getAttribute(u);
                "" == e || null == e
                    ? (t.classList.add("hide"), (document.cookie = "countDownHours=" + i), (document.cookie = "countDownMinutes=" + d), (document.cookie = "countDownSeconds=" + l), window.location.reload())
                    : (t.textContent = e);
            }),
            (counter = setInterval(() => {
                0 == b && 0 == v && 0 == f && clearInterval(counter, finished()),
                    f >= 0 &&
                        (timer(f, v, b),
                        (p.textContent = checkValue(b)),
                        (m.textContent = checkValue(v)),
                        (h.textContent = checkValue(f)),
                        0 != f && ((document.cookie = "countDownHours=" + b), (document.cookie = "countDownMinutes=" + v), (document.cookie = "countDownSeconds=" + f)));
            }, e));
    }
    if (document.querySelector(".stock-progress")) {
        var u = document.querySelector(".stock p b").textContent,
            p = document.querySelector(".button.button-cart"),
            m = getCookie("urgencyProductItem");
        m && ((document.querySelector(".stock p b").textContent = m), (document.querySelector(".progress-bar").style = "width: 85%"), (document.querySelector(".progress .fire").style = "left: 80%")),
            (document.body.onscroll = function () {
                p.getBoundingClientRect().bottom <= window.innerHeight &&
                    ((document.body.onscroll = ""),
                    document.querySelector(".stock p b").textContent > 4 &&
                        setTimeout(() => {
                            var e = u - 2;
                            (document.querySelector(".progress-bar").style = "width: 85%"),
                                (document.querySelector(".progress .fire").style = "left: 80%"),
                                (document.querySelector(".stock p b").textContent = e),
                                (document.cookie = "urgencyProductItem=" + e);
                        }, 4e3));
            });
    }
    var h = document.querySelector("span.item-count.cart-count");
    h &&
        !document.querySelector(".cart-template") &&
        Number(h.textContent) > 0 &&
        (document.querySelector(".header-middle .cart a[tip]") && document.querySelector(".header-middle .cart a[tip]").setAttribute("tip", "Seus produtos estão esperando você! 😍"),
        document.querySelector(".header-middle .cart a.cart-button i").classList.add("product-added"),
        h.classList.add("product-added"));
    var g = document.querySelector(".datasheet-fields");
    if (g)
        for (var S = JSON.parse(g.innerHTML), q = document.querySelector("table.datasheet"), w = 0; w < S.length; w++) {
            var x = q.insertRow(),
                k = x.insertCell(),
                L = x.insertCell();
            (k.innerHTML = S[w]), w++, (L.innerHTML = S[w]);
        }
    var C = document.querySelector(".faq-fields");
    if (C) {
        S = JSON.parse(C.innerHTML);
        var A = document.querySelector(".faq-accordion");
        for (w = 0; w < S.length; w++) {
            ((I = document.createElement("button")).className = "accordion"), A.appendChild(I), I.append(S[w]), 0 === w && I.classList.add("open");
            var E = document.createElement("div");
            (E.className = "accordion-content"), A.appendChild(E), w++;
            var M = document.createElement("p");
            if ((E.appendChild(M), S[w].includes("[img="))) {
                var T = S[w].split("[img=").pop().replace("]", ""),
                    _ = `[img=${T}]`,
                    H = `<img src="${T}" loading="lazy">`;
                M.innerHTML = S[w].replace(_, H);
            } else M.innerHTML = S[w];
        }
    }
    document.querySelectorAll(".mobile-menu > ul > li.child").forEach((e) => {
        const trigger = e.querySelector(":scope > a");
        const childMenu = e.querySelector(":scope > .menu-child-mobile");

        if (!trigger || !childMenu) return;

        trigger.addEventListener("click", (t) => {
            t.preventDefault();

            const isOpen = e.classList.contains("open");

            // Fecha os outros menus
            document
                .querySelectorAll(".mobile-menu > ul > li.child.open")
                .forEach((item) => {

                    if (item === e) return;

                    item.classList.remove("open");

                    const menu = item.querySelector(":scope > .menu-child-mobile");

                    if (menu) {
                        menu.style.maxHeight = "0px";
                    }
                });

            // Abre/fecha o atual
            if (isOpen) {

                e.classList.remove("open");
                childMenu.style.maxHeight = "0px";

            } else {

                e.classList.add("open");
                childMenu.style.maxHeight = childMenu.scrollHeight + "px";

            }
        });
    });
    const headerMenu = document.querySelector(".header-menu");
    if (headerMenu) {
        const allItems = headerMenu.querySelectorAll(":scope > li");
        const itemsWithChild = headerMenu.querySelectorAll(":scope > li.has-child");
        let megaMenuClosingTimer = null;

        const headerBottom = headerMenu.closest(".header-bottom");

        function isMegaMenuBlocked() {
            return document.body.classList.contains("block-overflow");
        }

        headerBottom.addEventListener("mouseenter", () => {
            if (isMegaMenuBlocked()) return;

            headerBottom.classList.add("menu-hovering");
        });

        headerBottom.addEventListener("mouseleave", () => {
            headerBottom.classList.remove("menu-hovering");
        });

        const safeDistance = 10;

        function positionMegaMenu(item) {
            const submenu = item.querySelector(":scope > .header-submenu");

            if (!submenu) return;

            const itemRect = item.getBoundingClientRect();
            const menuRect = headerMenu.getBoundingClientRect();

            const left = Math.max(0, itemRect.left - menuRect.left);

            submenu.style.left = `${left}px`;
            submenu.style.right = "0";
            submenu.style.width = "auto";
        }

        function closeAllMegaMenus() {
            itemsWithChild.forEach((item) => {
                item.classList.remove("active");
                item.classList.remove("focus");
            });

            document.body.classList.remove("mega-menu-active");
            document.body.classList.add("mega-menu-closing");

            searchOverlay.classList.remove("show");

            if (megaMenuClosingTimer) {
                clearTimeout(megaMenuClosingTimer);
            }

            megaMenuClosingTimer = setTimeout(() => {
                const activeMegaMenu = headerMenu.querySelector(
                    ":scope > li.has-child.active"
                );

                if (!activeMegaMenu) {
                    document.body.classList.remove("mega-menu-closing");
                }

                megaMenuClosingTimer = null;
            }, 500);
        }

        function openMegaMenu(item) {
            if (isMegaMenuBlocked()) return;

            if (megaMenuClosingTimer) {
                clearTimeout(megaMenuClosingTimer);
                megaMenuClosingTimer = null;
            }

            document.body.classList.remove("mega-menu-closing");
            document.body.classList.add("mega-menu-active");

            searchOverlay.classList.add("show");

            positionMegaMenu(item);

            itemsWithChild.forEach((otherItem) => {
                if (otherItem !== item) {
                    otherItem.classList.remove("active", "focus");
                }
            });

            requestAnimationFrame(() => {
                if (isMegaMenuBlocked()) return;

                item.classList.add("active", "focus");
            });
        }

        function isInsideSafeArea(event, rect) {
            return (
                event.clientX >= rect.left - safeDistance &&
                event.clientX <= rect.right + safeDistance &&
                event.clientY >= rect.top - safeDistance &&
                event.clientY <= rect.bottom + safeDistance
            );
        }

        function getTopMenuItemAtPointer(x, y) {
            if (isMegaMenuBlocked()) return null;

            for (const item of allItems) {
                const rect = item.getBoundingClientRect();

                if (
                    x >= rect.left &&
                    x <= rect.right &&
                    y >= rect.top &&
                    y <= rect.bottom
                ) {
                    return item;
                }
            }

            return null;
        }

        document.addEventListener("pointermove", (event) => {
            if (isMegaMenuBlocked()) return;

            const hoveredItem = getTopMenuItemAtPointer(
                event.clientX,
                event.clientY
            );

            if (!hoveredItem) return;

            const currentActive = headerMenu.querySelector(
                ":scope > li.has-child.active"
            );

            if (hoveredItem.classList.contains("has-child")) {
                if (hoveredItem !== currentActive) {
                    openMegaMenu(hoveredItem);
                }
            } else if (currentActive) {
                closeAllMegaMenus();
            }
        });

        /*
        * 10px DE TOLERÂNCIA SOMENTE PARA SAÍDA.
        */
        document.addEventListener("pointermove", (event) => {
            if (isMegaMenuBlocked()) return;

            const hoveredItem = getTopMenuItemAtPointer(
                event.clientX,
                event.clientY
            );

            if (hoveredItem) {
                const currentActive = headerMenu.querySelector(
                    ":scope > li.has-child.active"
                );

                if (hoveredItem.classList.contains("has-child")) {
                    if (hoveredItem !== currentActive) {
                        openMegaMenu(hoveredItem);
                    }
                } else if (currentActive) {
                    closeAllMegaMenus();
                }

                return;
            }

            const activeItem = headerMenu.querySelector(
                ":scope > li.has-child.active"
            );

            if (!activeItem) return;

            const trigger = activeItem.querySelector(":scope > a");
            const submenu = activeItem.querySelector(
                ":scope > .header-submenu"
            );

            if (!trigger || !submenu) return;

            const nearTrigger = isInsideSafeArea(
                event,
                trigger.getBoundingClientRect()
            );

            const nearSubmenu = isInsideSafeArea(
                event,
                submenu.getBoundingClientRect()
            );

            if (!nearTrigger && !nearSubmenu) {
                closeAllMegaMenus();
            }
        });

        /*
        * INTERAÇÕES DENTRO DO MEGA MENU
        */
        itemsWithChild.forEach((item) => {
            const submenu = item.querySelector(":scope > .header-submenu");

            if (!submenu) return;

            submenu.addEventListener("click", (event) => {
                if (isMegaMenuBlocked()) return;

                event.stopPropagation();

                searchOverlay.classList.add("show");
            });

            submenu.addEventListener("pointerdown", (event) => {
                if (isMegaMenuBlocked()) return;

                event.stopPropagation();

                searchOverlay.classList.add("show");
            });

            submenu.addEventListener("contextmenu", (event) => {
                if (isMegaMenuBlocked()) return;

                event.stopPropagation();

                requestAnimationFrame(() => {
                    if (
                        !isMegaMenuBlocked() &&
                        item.classList.contains("active")
                    ) {
                        searchOverlay.classList.add("show");
                    }
                });
            });
        });

        /*
        * PROTEÇÃO DO OVERLAY
        */
        const megaMenuOverlayGuard = new MutationObserver(() => {
            if (isMegaMenuBlocked()) return;

            const hasActiveMegaMenu = headerMenu.querySelector(
                ":scope > li.has-child.active"
            );

            if (
                hasActiveMegaMenu &&
                !searchOverlay.classList.contains("show")
            ) {
                searchOverlay.classList.add("show");
            }
        });

        megaMenuOverlayGuard.observe(searchOverlay, {
            attributes: true,
            attributeFilter: ["class"]
        });

        /*
        * Recalcula caso a janela mude de tamanho.
        */
        window.addEventListener("resize", () => {
            if (isMegaMenuBlocked()) return;

            const activeItem = headerMenu.querySelector(
                ":scope > li.has-child.active"
            );

            if (activeItem) {
                positionMegaMenu(activeItem);
            }
        });
    }
    document.querySelectorAll(".mega-products-swiper").forEach((swiperElement) => {
        const section = swiperElement.closest(".mega-menu-products");
        const slideCount = swiperElement.querySelectorAll(".swiper-slide").length;

        new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 15,
            speed: 500,

            observer: true,
            observeParents: true,

            loop: slideCount > 1,

            autoplay: slideCount > 1 ? {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            } : false,

            pagination: {
                el: section.querySelector(".mega-products-pagination"),
                clickable: true,
                bulletClass: "global-slider-dot",
                bulletActiveClass: "is-active"
            },

            navigation: {
                nextEl: section.querySelector(".mega-menu-next"),
                prevEl: section.querySelector(".mega-menu-prev")
            }
        });
    });
    (function () {
        var calculators = document.querySelectorAll(
            ".product-shipping-calculator"
        );

        if (!calculators.length) return;

        /*
        * Feriados ou datas sem entrega.
        *
        * Formato:
        * "AAAA-MM-DD"
        *
        * Exemplo:
        * "2026-09-07"
        *
        * Se não quiser cadastrar feriados,
        * deixe o array vazio.
        */
        var shippingHolidays = [
            // "2026-09-07",
            // "2026-10-12"
        ];

        function formatCep(value) {
            value = value.replace(/\D/g, "");
            value = value.substring(0, 8);

            if (value.length > 5) {
                value =
                    value.substring(0, 5) +
                    "-" +
                    value.substring(5);
            }

            return value;
        }

        function isHoliday(date) {
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var day = String(date.getDate()).padStart(2, "0");

            var formatted =
                year + "-" + month + "-" + day;

            return shippingHolidays.indexOf(formatted) !== -1;
        }

        function addBusinessDays(startDate, businessDays) {
            var date = new Date(startDate);

            /*
            * Zera hora/minuto/segundo para evitar problemas
            * em mudanças de horário.
            */
            date.setHours(12, 0, 0, 0);

            var addedDays = 0;

            while (addedDays < businessDays) {
                date.setDate(date.getDate() + 1);

                var dayOfWeek = date.getDay();

                var isWeekend =
                    dayOfWeek === 0 ||
                    dayOfWeek === 6;

                if (!isWeekend && !isHoliday(date)) {
                    addedDays++;
                }
            }

            return date;
        }

        function formatDeliveryDate(date) {
            var weekdays = [
                "Domingo",
                "Segunda",
                "Terça",
                "Quarta",
                "Quinta",
                "Sexta",
                "Sábado"
            ];

            /*
            * Segurança extra:
            * se por qualquer motivo a data final cair
            * no sábado ou domingo, passa para segunda.
            */
            var dayOfWeek = date.getDay();

            if (dayOfWeek === 6) {
                date.setDate(date.getDate() + 2);
            } else if (dayOfWeek === 0) {
                date.setDate(date.getDate() + 1);
            }

            var weekday = weekdays[date.getDay()];

            var day = String(date.getDate()).padStart(2, "0");

            var month = date.toLocaleDateString(
                "pt-BR",
                {
                    month: "long"
                }
            );

            return (
                "Chegará na " +
                weekday +
                ", dia " +
                day +
                " de " +
                month +
                "."
            );
        }

        calculators.forEach(function (calculator) {
            if (calculator.dataset.shippingInitialized === "true") {
                return;
            }

            calculator.dataset.shippingInitialized = "true";

            var form = calculator.querySelector(
                ".product-shipping-calculator__form"
            );

            var input = calculator.querySelector(
                ".product-shipping-calculator__input"
            );

            var button = calculator.querySelector(
                ".product-shipping-calculator__button"
            );

            var message = calculator.querySelector(
                ".product-shipping-calculator__message"
            );

            var loading = calculator.querySelector(
                ".product-shipping-calculator__loading"
            );

            var results = calculator.querySelector(
                ".product-shipping-calculator__results"
            );

            var freeDateElement = calculator.querySelector(
                '[data-shipping-date="free"]'
            );

            var expressDateElement = calculator.querySelector(
                '[data-shipping-date="express"]'
            );

            var cepResultElement = calculator.querySelector(
                "[data-shipping-cep]"
            );

            var freeDays = parseInt(
                calculator.dataset.freeDays,
                10
            ) || 5;

            var expressDays = parseInt(
                calculator.dataset.expressDays,
                10
            ) || 3;

            var loadingTimer = null;

            input.addEventListener("input", function () {
                this.value = formatCep(this.value);

                this.classList.remove("error");

                message.classList.remove("show");
                message.textContent = "";

                results.classList.remove("show");
            });

            form.addEventListener("submit", function (event) {
                event.preventDefault();

                var cep = input.value.replace(/\D/g, "");

                clearTimeout(loadingTimer);

                results.classList.remove("show");
                message.classList.remove("show");
                message.textContent = "";

                input.classList.remove("error");

                if (cep.length !== 8) {
                    input.classList.add("error");

                    message.textContent =
                        "Digite um CEP válido com 8 números.";

                    message.classList.add("show");

                    input.focus();

                    return;
                }

                loading.classList.add("show");

                button.disabled = true;
                button.textContent = "Calculando...";

                /*
                * Consulta o CEP para evitar que um CEP
                * inexistente apresente prazo de entrega.
                */
                fetch(
                    "https://viacep.com.br/ws/" +
                    cep +
                    "/json/"
                )
                    .then(function (response) {
                        if (!response.ok) {
                            throw new Error("Erro na consulta");
                        }

                        return response.json();
                    })

                    .then(function (data) {
                        /*
                        * Mantém o loading por pelo menos 2 segundos,
                        * conforme solicitado.
                        */
                        loadingTimer = setTimeout(function () {
                            loading.classList.remove("show");

                            button.disabled = false;
                            button.textContent = "Calcular";

                            if (data.erro) {
                                input.classList.add("error");

                                message.textContent =
                                    "CEP não encontrado. Confira e tente novamente.";

                                message.classList.add("show");

                                input.focus();

                                return;
                            }

                            cepResultElement.textContent = formatCep(cep);

                            var today = new Date();

                            var freeDelivery =
                                addBusinessDays(
                                    today,
                                    freeDays
                                );

                            var expressDelivery =
                                addBusinessDays(
                                    today,
                                    expressDays
                                );

                            freeDateElement.textContent =
                                formatDeliveryDate(
                                    freeDelivery
                                );

                            expressDateElement.textContent =
                                formatDeliveryDate(
                                    expressDelivery
                                );

                            results.classList.add("show");
                        }, 2000);
                    })

                    .catch(function () {
                        loadingTimer = setTimeout(function () {
                            loading.classList.remove("show");

                            button.disabled = false;
                            button.textContent = "Calcular";

                            input.classList.add("error");

                            message.textContent =
                                "Não foi possível consultar o CEP agora. Tente novamente.";

                            message.classList.add("show");
                        }, 2000);
                    });
            });
        });
    })();
    var F = document.querySelector("#add-new-address");
    F &&
        (I = document.querySelector("button[data-modal='add-new-address']")).addEventListener("click", () => {
            validAddressForm(F);
        });
    document.querySelector(".customer-edit-address-button") &&
        document.querySelectorAll(".customer-edit-address-button").forEach((e) => {
            e.addEventListener("click", (t) => {
                t.preventDefault();
                var o = e.dataset.id,
                    r = document.querySelector("#edit-" + o);
                $.ajax({
                    success: function () {
                        validAddressForm(r);
                    },
                    error: function () {
                        console.log("Erro ao editar o endereço: " + error);
                    },
                });
            });
        }),
        document.querySelector(".customer-remove-address") &&
            document.querySelectorAll(".customer-remove-address").forEach((e) => {
                var t = e.dataset.id;
                e.querySelector(`#remove-${t} button[type="submit"]`).addEventListener("click", (e) => {
                    e.preventDefault(),
                        $.ajax({
                            success: function () {
                                Shopify.CustomerAddress.destroy(t);
                            },
                            error: function () {
                                console.log("Erro ao remover endereço: " + error);
                            },
                        });
                });
            });
    var R = document.getElementsByClassName("accordion");
    for (let e = 0; e < R.length; e++)
        R[e].addEventListener("click", function () {
            for (let t = 0; t < R.length; t++) R[t].classList.remove("active"), t != e && (R[t].nextElementSibling.style.maxHeight = null);
            this.classList.add("active");
            var t = this.nextElementSibling;
            t.style.maxHeight ? ((t.style.maxHeight = null), this.classList.remove("active")) : (t.style.maxHeight = t.scrollHeight + "px");
        });
    var I,
        N = document.querySelector(".accordion.open");
    (N && N.click(), document.querySelector(".expand-button")) &&
        (I = document.querySelector(".expand-footer")).addEventListener("click", () => {
            var e = document.querySelector(".expand-footer span"),
                t = document.querySelector(".footer-middle"),
                o = document.querySelector(".expand-footer i");
            t.classList.contains("expand")
                ? (t.classList.remove("expand"), (t.style.maxHeight = null), o.classList.remove("rotate"), (e.innerText = "Mais informações"))
                : (t.classList.add("expand"), (t.style.maxHeight = t.scrollHeight + "px"), o.classList.add("rotate"), (e.innerText = "Menos informações"));
        });
        (function () {
        var content = document.querySelector('.description.minimized');
        var button = document.querySelector('.button-expand-text');

        if (!content || !button) return;

        button.addEventListener("click", function () {
            var isExpanded = content.classList.contains("expand");

            if (!isExpanded) {
                content.classList.add("expand");
                content.classList.remove("faded");
                content.style.maxHeight = content.scrollHeight + "px";
                button.innerText = "Mostrar menos";

            } else {
                var element = document.querySelector('.product-description-container');

                if (element) {
                    window.scrollTo({
                        top: element.offsetTop,
                        behavior: 'smooth'
                    });
                }

                content.classList.remove("expand");
                content.classList.add("faded");
                content.style.maxHeight = null;
                button.innerText = "Mostrar mais";
            }
        });

    })();
    if (document.querySelector(".button-recompense-system-confetti")) {
        const e = 90,
            t = 15,
            o = 0.15,
            r = 0.25,
            a = 0.075,
            n = 0.02,
            c = 3;
        let s = [],
            i = [];
        const d = [
                { front: "#0086ff", back: "#6245e0" },
                { front: "#f9377e", back: "#df83a4" },
                { front: "#fcd000", back: "#f3df80" },
            ],
            l = ["Parabéns! Ótima escolha", "Arrasou na escolha!", "Excelente escolha, parabéns!"];
        (randomRange = (e, t) => Math.random() * (t - e) + e),
            (initConfettoVelocity = (e, t) => {
                const o = randomRange(e[0], e[1]),
                    r = t[1] - t[0] + 1;
                let a = t[1] - Math.abs(randomRange(0, r) + randomRange(0, r) - r);
                return a >= t[1] - 1 && (a += Math.random() < 0.25 ? randomRange(1, 3) : 0), { x: o, y: -a };
            }),
            document.querySelectorAll(".button-recompense-system-confetti").forEach((u) => {
                u.addEventListener("click", (p) => {
                    p.preventDefault();
                    var m = !1,
                        h = u.dataset.handle,
                        y = parseInt(u.dataset.x),
                        f = u.getBoundingClientRect(),
                        v = u.querySelector(".successMessage span.button-text"),
                        b = l[Math.floor(Math.random() * l.length)];
                    const g = document.querySelector(`.confetti[data-handle="${h}"]`),
                        S = g.getContext("2d");
                    (g.width = window.innerWidth), (g.height = window.innerHeight);
                    let q = S.canvas.width / 2,
                        w = S.canvas.height / 2;
                    function $() {
                        (this.randomModifier = randomRange(0, 99)),
                            (this.color = d[Math.floor(randomRange(0, d.length))]),
                            (this.dimensions = { x: randomRange(5, 9), y: randomRange(8, 15) }),
                            (this.position = y ? { x: f.x + y, y: f.y + 35 } : { x: randomRange(g.width / 2 - u.offsetWidth / 4, g.width / 2 + u.offsetWidth / 4), y: f.y + 35 }),
                            (this.rotation = randomRange(0, 2 * Math.PI)),
                            (this.scale = { x: 1, y: 1 }),
                            (this.velocity = initConfettoVelocity([-9, 9], [6, 11]));
                    }
                    function x() {
                        (this.color = d[Math.floor(randomRange(0, d.length))].back),
                            (this.radius = randomRange(1, 2)),
                            (this.position = y ? { x: f.x + y, y: f.y + 35 } : { x: randomRange(g.width / 2 - u.offsetWidth / 3, g.width / 2 + u.offsetWidth / 3), y: f.y + 35 }),
                            (this.velocity = { x: randomRange(-6, 6), y: randomRange(-8, -12) });
                    }
                    (v.innerHTML = b),
                        ($.prototype.update = function () {
                            (this.velocity.x -= this.velocity.x * a),
                                (this.velocity.y = Math.min(this.velocity.y + o, c)),
                                (this.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random()),
                                (this.position.x += this.velocity.x),
                                (this.position.y += this.velocity.y),
                                (this.scale.y = Math.cos(0.09 * (this.position.y + this.randomModifier)));
                        }),
                        (x.prototype.update = function () {
                            (this.velocity.x -= this.velocity.x * n), (this.velocity.y = this.velocity.y + r), (this.position.x += this.velocity.x), (this.position.y += this.velocity.y);
                        }),
                        (initBurst = () => {
                            for (let t = 0; t < e; t++) s.push(new $());
                            for (let e = 0; e < t; e++) i.push(new x());
                        }),
                        (render = () => {
                            S.clearRect(0, 0, g.width, g.height),
                                s.forEach((e, t) => {
                                    let o = e.dimensions.x * e.scale.x,
                                        r = e.dimensions.y * e.scale.y;
                                    S.translate(e.position.x, e.position.y),
                                        S.rotate(e.rotation),
                                        e.update(),
                                        (S.fillStyle = e.scale.y > 0 ? e.color.front : e.color.back),
                                        S.fillRect(-o / 2, -r / 2, o, r),
                                        S.setTransform(1, 0, 0, 1, 0, 0),
                                        e.velocity.y < 0 && S.clearRect(g.width / 2 - u.offsetWidth / 2, g.height / 2 + u.offsetHeight / 2, u.offsetWidth, u.offsetHeight);
                                }),
                                i.forEach((e, t) => {
                                    S.translate(e.position.x, e.position.y),
                                        e.update(),
                                        (S.fillStyle = e.color),
                                        S.beginPath(),
                                        S.arc(0, 0, e.radius, 0, 2 * Math.PI),
                                        S.fill(),
                                        S.setTransform(1, 0, 0, 1, 0, 0),
                                        e.velocity.y < 0 && S.clearRect(g.width / 2 - u.offsetWidth / 2, g.height / 2 + u.offsetHeight / 2, u.offsetWidth, u.offsetHeight);
                                }),
                                s.forEach((e, t) => {
                                    e.position.y >= g.height && s.splice(t, 1);
                                }),
                                i.forEach((e, t) => {
                                    e.position.y >= g.height && i.splice(t, 1);
                                }),
                                window.requestAnimationFrame(render);
                        }),
                        (clickButton = () => {
                            m ||
                                ((m = !0),
                                u.classList.add("loading"),
                                u.classList.remove("ready"),
                                (u.disabled = !0),
                                setTimeout(() => {
                                    u.classList.add("complete"),
                                        u.classList.remove("loading"),
                                        setTimeout(() => {
                                            var e = document.querySelector(".window-modal .window-modal-content");
                                            e && e.classList.add("overflow-hidden"),
                                                window.initBurst(),
                                                setTimeout(() => {
                                                    (m = !1), u.classList.add("ready"), u.classList.remove("complete"), e && e.classList.remove("overflow-hidden"), (v.textContent = "");
                                                }, 6e3);
                                        }, 190);
                                }, 0));
                        }),
                        (resizeCanvas = () => {
                            (g.width = window.innerWidth), (g.height = window.innerHeight), (q = S.canvas.width / 2), (w = S.canvas.height / 2);
                        }),
                        window.addEventListener("resize", () => {
                            resizeCanvas();
                        }),
                        (textElements = u.querySelectorAll(".button-text")),
                        textElements.forEach((e) => {
                            characters = e.innerHTML.split("");
                            let t = "";
                            characters.forEach((e, o) => {
                                t += `<span class="char${o}" style="--d:${30 * o}ms; --dr:${30 * (characters.length - o - 1)}ms;">${e}</span>`;
                            }),
                                (e.innerHTML = t);
                        }),
                        render(),
                        clickButton();
                });
            });
    }
    document.querySelectorAll(".checkbox.tags input").forEach((e) => {
        e.addEventListener("click", (t) => {
            var o = formatText(e.getAttribute("id")),
                r = new URL(window.location),
                a = window.location.search;
            if (0 == e.checked) {
                var n = r.pathname.split("/").pop().split("+");
                if (n.length > 1) var c = n.filter((e) => e !== o).join("+") + a;
                else c = (s = r.toString()).replace("/" + o, "");
                window.location = c;
            } else {
                if (r.pathname.split("/").length - 1 < 3)
                    if ("" == a) window.location = r + "/" + o;
                    else {
                        r = window.location.toString();
                        var s = insertBeforeFirst(r, "?", "/" + o);
                        window.location = s;
                    }
                else if ("" == a) window.location = r + "+" + o;
                else {
                    (r = window.location.toString()), (s = insertBeforeFirst(r, "?", "+" + o));
                    window.location = s;
                }
            }
        });
    }),
        document.querySelector(".wishlist-action button.button-cart") &&
            (document.querySelectorAll(".wishlist-action button.button-cart").forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    var o = e.dataset.handle;
                    axios.get("/products/" + o + ".json").then((e) => {
                        var t = e.data.product,
                            o = t.handle;
                        document.querySelectorAll(`.selector-type[data-handle="${o}"] .product-options input[type="radio"]`).forEach((e) => {
                            e.addEventListener("change", () => {
                                var e = [];
                                document.querySelectorAll(`.selector-type[data-handle="${o}"] .product-options input[type="radio"]:checked`).forEach((t) => {
                                    e.push(t.value);
                                });
                                for (var r = { variants: [] }, a = 0; a < t.variants.length; a++) {
                                    for (var n = [], c = 0; c < e.length; c++) {
                                        var s = Number(c + 1),
                                            i = t.variants[a]["option" + s];
                                        n.push(i);
                                    }
                                    r.variants.push({
                                        id: t.variants[a].id,
                                        compare_at_price: t.variants[a].compare_at_price,
                                        price: t.variants[a].price,
                                        position: t.variants[a].position,
                                        title: t.variants[a].title,
                                        image_id: t.variants[a].image_id,
                                        options: n,
                                    });
                                }
                                var d = r.variants.find((t) => {
                                        for (var o = !0, r = 0; r < e.length; r++)
                                            if (-1 === e.indexOf(t.options[r])) {
                                                o = !1;
                                                break;
                                            }
                                        return o;
                                    }),
                                    l = t.images.filter((e) => e.id === d.image_id);
                                document.querySelector(`.buy-modal .body[data-handle="${t.handle}"] img.product-image`).setAttribute("src", l[0].src), (document.querySelector("#product-id-" + t.id).value = d.id);
                                var u = document.querySelectorAll(`[data-handle="${t.handle}"] span.option-name`);
                                if (u.length > 1) {
                                    var p = d.title.split("/");
                                    for (a = 1; a <= u.length; a++) {
                                        document.querySelector(`[data-handle="${t.handle}"] [data-selected-position="${a}"]`).textContent = p[a - 1].trim();
                                    }
                                } else document.querySelector(`[data-handle="${t.handle}"] span.option-selected`).textContent = d.title;
                            });
                        }),
                            document.querySelectorAll(`.selector-type[data-handle="${o}"][data-selector-type="image"] .option label`).forEach((e) => {
                                e.addEventListener("click", () => {
                                    document.querySelector(`.selector-type[data-handle="${o}"][data-selector-type="image"] .option label.selected`).classList.remove("selected"), e.classList.add("selected");
                                });
                            }),
                            document.querySelectorAll(`.selector-type[data-handle="${o}"][data-selector-type="block"] .option label`).forEach((e) => {
                                e.addEventListener("click", () => {
                                    document.querySelector(`.selector-type[data-handle="${o}"][data-selector-type="block"] .option label.selected`).classList.remove("selected"), e.classList.add("selected");
                                });
                            }),
                            document.querySelectorAll(`.buy-modal button[data-handle="${t.handle}"]`).forEach((e) => {
                                e.addEventListener("click", () => {
                                    var e = document.querySelector("#product-id-" + t.id).value;
                                    setTimeout(() => {
                                        window.location = "../cart/add/" + e;
                                    }, 3e3);
                                });
                            });
                    });
                });
            }),
            document.querySelectorAll(".button-default.remove").forEach((e) => {
                e.addEventListener("click", (e) => {
                    var t = Number(document.querySelector(".item-count.wishlist-count").textContent) - 1,
                        o = document.querySelector("h1 span").textContent;
                    if (0 == t) {
                        var r = document.createElement("div"),
                            a = document.querySelector("h1");
                        r.setAttribute("class", "white-card"),
                            (r.innerHTML = `<p>${o}, você removeu todos seus favoritos. Recomece a achar produtos <a href="/collections/all">clicando aqui</a> e adicione-os!</p>`),
                            document.querySelector("p.info-description").remove(),
                            a.parentNode.insertBefore(r, a.nextSibling);
                    }
                });
            })),
        document.querySelector(".cart-template .product-upsell") &&
            document.querySelectorAll(".cart-template .product-upsell button.button-variants").forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    var o = e.dataset.handle;
                    axios.get("/products/" + o + ".json").then((e) => {
                        var t = e.data.product,
                            o = t.handle;
                        document.querySelectorAll(`.selector-type[data-handle="${o}"] .product-options input[type="radio"]`).forEach((e) => {
                            e.addEventListener("change", () => {
                                var e = [];
                                document.querySelectorAll(`.selector-type[data-handle="${o}"] .product-options input[type="radio"]:checked`).forEach((t) => {
                                    e.push(t.value);
                                });
                                for (var r = { variants: [] }, a = 0; a < t.variants.length; a++) {
                                    for (var n = [], c = 0; c < e.length; c++) {
                                        var s = Number(c + 1),
                                            i = t.variants[a]["option" + s];
                                        n.push(i);
                                    }
                                    r.variants.push({
                                        id: t.variants[a].id,
                                        compare_at_price: t.variants[a].compare_at_price,
                                        price: t.variants[a].price,
                                        position: t.variants[a].position,
                                        title: t.variants[a].title,
                                        image_id: t.variants[a].image_id,
                                        options: n,
                                    });
                                }
                                var d = r.variants.find((t) => {
                                        for (var o = !0, r = 0; r < e.length; r++)
                                            if (-1 === e.indexOf(t.options[r])) {
                                                o = !1;
                                                break;
                                            }
                                        return o;
                                    }),
                                    l = t.images.filter((e) => e.id === d.image_id);
                                document.querySelector(`.buy-modal .body[data-handle="${t.handle}"] img.product-image`).setAttribute("src", l[0].src),
                                    (document.querySelector("#product-id-" + t.id).value = d.id),
                                    (document.querySelector(`#variants-${t.id} button.send-upsell`).dataset.product = d.id),
                                    (document.querySelector(`#variants-${t.id} button.send-upsell`).dataset.oldPrice = unFormatMoney(d.compare_at_price));
                                var u = document.querySelectorAll(`[data-handle="${t.handle}"] span.option-name`);
                                if (u.length > 1) {
                                    var p = d.title.split("/");
                                    for (a = 1; a <= u.length; a++) {
                                        document.querySelector(`[data-handle="${t.handle}"] [data-selected-position="${a}"]`).textContent = p[a - 1].trim();
                                    }
                                } else document.querySelector(`[data-handle="${t.handle}"] span.option-selected`).textContent = d.title;
                            });
                        }),
                            document.querySelectorAll(`.selector-type[data-handle="${o}"][data-selector-type="image"] .option label`).forEach((e) => {
                                e.addEventListener("click", () => {
                                    document.querySelector(`.selector-type[data-handle="${o}"][data-selector-type="image"] .option label.selected`).classList.remove("selected"), e.classList.add("selected");
                                });
                            }),
                            document.querySelectorAll(`.selector-type[data-handle="${o}"][data-selector-type="block"] .option label`).forEach((e) => {
                                e.addEventListener("click", () => {
                                    var t = e.id;
                                    document.querySelector(`.selector-type[data-handle="${o}"][data-selector-type="block"] .option label#${t}.selected`).classList.remove("selected"), e.classList.add("selected");
                                });
                            }),
                            document.querySelectorAll(`.buy-modal button[data-handle="${t.handle}"]`).forEach((e) => {
                                e.addEventListener("click", () => {
                                    document.querySelector("#variants-" + t.id).click();
                                });
                            });
                    });
                });
            }),
        document.querySelector(".wishlist-action button.button-cart.one-variant") &&
            document.querySelectorAll(".wishlist-action button.button-cart.one-variant").forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    var o = e.dataset.product;
                    window.location = "../cart/add/" + o;
                });
            });
    var D = getCookie("collectionDisplayButton");
    if (D && "list" == D) {
        var P = document.querySelector("button.collection-list"),
            B = document.querySelector("button.collection-grid");
        P &&
            B &&
            (P.classList.add("active"),
            B.classList.remove("active"),
            document.querySelectorAll(".single-product").forEach((e) => {
                e.classList.add("list");
            }),
            document.querySelectorAll(".collection-products").forEach((e) => {
                e.classList.add("list");
            }));
    }

    document.querySelectorAll(".display-options button").forEach((e) => {
        e.addEventListener("click", (t) => {
            t.preventDefault();
            var o = document.querySelector("button.collection-grid"),
                r = document.querySelector("button.collection-list");

            e.classList.contains("collection-list")
                ? ((document.cookie = "collectionDisplayButton=list"),
                r.classList.add("active"),
                o.classList.remove("active"),
                document.querySelectorAll(".single-product").forEach((e) => {
                    e.classList.add("list");
                }),
                document.querySelectorAll(".collection-products").forEach((e) => {
                    e.classList.add("list");
                }))
                : ((document.cookie = "collectionDisplayButton=grid"),
                o.classList.add("active"),
                r.classList.remove("active"),
                document.querySelectorAll(".single-product").forEach((e) => {
                    e.classList.remove("list");
                }),
                document.querySelectorAll(".collection-products").forEach((e) => {
                    e.classList.remove("list");
                }));
        });
    });
    var O = document.querySelector("#order-by"),
        j = new URL(window.location).searchParams.get("sort_by");
    function V() {
        $(".search-overlay").addClass("show");
        $("body").addClass("block-overflow");
    }
    function hasOpenOverlayElement() {
        return (
            $(".mobile-menu.show-menu").length ||
            $(".mini-cart.open, .mini-cart.show, .mini-cart.active").length ||
            $(".login-results.show").length ||
            $(".search-bar-content.open").length ||
            $("ul.departament-list.show").length
        );
    }
    function W(force) {
        if (!force && hasOpenOverlayElement()) return;

        $(".search-overlay").removeClass("show");
        $("body").removeClass("block-overflow");
    }
    null != O && (null == j ? document.querySelector("#order-by option[value='manual']").setAttribute("selected", "selected") : document.querySelector("#order-by option[value='" + j + "']").setAttribute("selected", "selected")),
        null != O &&
            O.addEventListener("change", () => {
                var e = new URL(window.location),
                    t = e.searchParams,
                    o = O.value;
                t.set("sort_by", o), (e.search = t.toString());
                var r = e.toString();
                window.location = r;
            }),
        $(".big-menu a.departaments").on("click", function () {
            setTimeout(function () {
                V(),
                    $("a.departaments, .big-menu").addClass("active"),
                    $("ul.departament-list").addClass("show"),
                    $("ul.departament-list").show(),
                    $(document).mouseup(function (e) {
                        !1 === $(e.target).is("ul.departament-list *") ? ($("a.departaments, .big-menu").removeClass("active"), $("ul.departament-list").removeClass("show"), $("ul.departament-list").hide(), W()) : V();
                    });
            }, 0);
        }),
        $(".account a.user").on("click", function (e) {
            e.preventDefault();

            setTimeout(function () {
                var $login = $(".login-results");
                var $headerFixed = $("header.is-fixed");
                var $searchContent = $("header.is-fixed .search-bar-content");

                // abre login
                $login.addClass("show");

                // aplica estados se o header estiver fixo
                if ($headerFixed.length) {
                    $headerFixed.addClass("focus");
                    $searchContent.addClass("unfocus");
                }

                V();
            }, 0);
        }),
        $(document).on("mouseup", function (e) {
            var $target = $(e.target);

            if ($target.closest(".mobile-menu, .menu-mobile-button, .mini-cart, .cart-button").length) {
                return;
            }

            if (!$target.closest(".account, .login-results").length) {
                $(".login-results").removeClass("show");

                var $headerFixed = $("header.is-fixed");
                var $searchContent = $("header.is-fixed .search-bar-content");

                $headerFixed.removeClass("focus");
                $searchContent.removeClass("unfocus");

                W();
            }
        }),
        $('.search-bar-content input[type="text"]').on("click", function () {
            $("header").addClass("focus"),
                V(),
                $(document).mouseup(function (e) {
                    !1 === $(e.target).is(".search-bar-content *") ? ($("input.search-bar").val(""), $("header").removeClass("focus"), $(".search-results").removeClass("search-box"), $(".search-results").empty(), W()) : V();
                });
        }),
        $(".menu-mobile-button").click(function () {
            setTimeout(function () {
                var e = $(".mobile-menu");

                V();
                e.addClass("show-menu");
                $("body").addClass("block-overflow mobile-menu-left");

                $(document).off("mouseup.mobileMenu").on("mouseup.mobileMenu", function (t) {
                    var $target = $(t.target);

                    if ($target.closest(".mini-cart, .cart-button").length) {
                        return;
                    }

                    if (!e.is(t.target) && e.has(t.target).length === 0) {
                        e.removeClass("show-menu");
                        $("body").removeClass("mobile-menu-left");

                        W();

                        $(document).off("mouseup.mobileMenu");
                    }
                });

            }, 0);
        });

        $("#closeMobileMenu").click(function () {
            var e = $(".mobile-menu");

            e.removeClass("show-menu");
            $("body").removeClass("block-overflow mobile-menu-left");
            W();

            $(document).off("mouseup.mobileMenu");
        });
    var z = -1,
        U = null,
        J = $(".search-results"),
        X = document.querySelector("[data-money-format]").getAttribute("data-money-format");

    $('.search-bar-content input[type="text"]')
        .bind("keyup change", function () {
            if ($(this).val().length > 0 && $(this).val() != $(this).data("oldval")) {
                $(this).data("oldval", $(this).val()), null != U && U.abort(), clearTimeout(z);
                var e = $(this).closest("form"),
                    t = "*" + e.find('input[name="q"]').val() + "*",
                    o = e.find('input[name="q"]').val(),
                    r = e.attr("action") + "?type=product&q=" + t;
                J.html('<div class="load"><i class="fas fa-circle-notch fa-spin"></i></div>'),
                    J.addClass("search-box"),
                    (z = setTimeout(function () {
                        U = $.ajax({
                            url: e.attr("action"),
                            data: { type: "product", view: "json", q: t },
                            dataType: "json",
                            success: function (t) {
                                if (((U = null), 0 == t.results_total)) J.html('<div class="not-found">☹️ Nada encontrado para <b>"' + o + '"</b>. Por favor, tente outras palavras!</div>');
                                else {
                                    J.empty(),
                                        J.append('<div class="results"></div>'),
                                        $(".results").append('<div class="search-links"></div>'),
                                        $(".search-links").append("<h3>sugestões</h3>"),
                                        $(".search-links").append("<ul></ul>"),
                                        $(".results").append('<div class="search-products"></div>'),
                                        $(".search-products").append("<h3>produtos encontrados</h3>"),
                                        $(".search-products").append('<div class="products-list"></div>'),
                                        $.each(t.results, function (t, o) {
                                            if (!(o.title.toLowerCase().indexOf("wholesale") > -1)) {
                                                var r = e.attr("action") + "?type=product&q=" + o.title;
                                                $(".search-links ul").append(`<li><a href="${r}">${o.title}</a></li>`);
                                            }
                                            return t < 7;
                                        }),
                                        $.each(t.results, function (e, t) {
                                            if (!(t.title.toLowerCase().indexOf("wholesale") > -1)) {
                                                var o = window.location.origin + t.url.split("?")[0] + ".json";
                                                $.getJSON(o, function (e) {
                                                    var o = e.product,
                                                        r = o.variants[0].compare_at_price;

                                                    if (r > 0) var a = '<div class="compare-price">' + formatMoney(r, X) + "</div>";
                                                    else a = "";

                                                    var n = $('<a class="item"></a>').attr("href", t.url);

                                                    var aspectRatio = document.querySelector('.carcase')?.getAttribute('data-aspect-ratio');

                                                    var aspectClass = '';
                                                    if (aspectRatio === '3/4') {
                                                        aspectClass = 'aspect-ratio-3-4';
                                                    } else if (aspectRatio === '1/1') {
                                                        aspectClass = 'aspect-ratio-1-1';
                                                    }

                                                    n.append('<img src="' + o.image.src + '" class="' + aspectClass + '" />'),
                                                    n.append(
                                                        `<div class="info">
                                                            <h3 class="title">${t.title}</h3>
                                                            <div class="price">
                                                            ${a}
                                                            ${t.price}
                                                            </div>
                                                        </div>`
                                                    ),
                                                    $(".products-list").append(n);
                                                });
                                            }
                                            return e < 2;
                                        });
                                    var a = $(".search-bar").val();
                                    $(".search-links ul li a").hover(function () {
                                        var e = this.textContent;
                                        $(".search-bar").val(e.toLowerCase());
                                    }),
                                        $(".search-links ul li a").mouseout(function () {
                                            $(".search-bar").val(a);
                                        }),
                                        $(".search-products").append('<div class="footer"><a href="' + r + '">Ver pesquisa completa <i class="fas fa-chevron-right"></i></a></div>');
                                }
                            },
                        });
                    }, 0));
            } else ($(this).val().length <= 0 || "" == $(this).val()) && (J.removeClass("search-box"), J.empty(), $(this).data("oldval", $(this).val()));
        })
        .attr("autocomplete", "off")
        .data("oldval", "")
        .bind("focusin", function () {
            J.fadeIn(200);
        })
        .bind("click", function (e) {
            e.stopPropagation();
        });

    $(".search-bar-w10, #search-bar-w10").on("submit", function (e) {
        e.preventDefault();
        var t = $(this).find('input[name="q"]').val(),
            o = $(this).attr("action") + "?type=product&q=" + t;
        window.location = o;
    });

    $("#customer_sidebar li:not(:first)").addClass("inactive");
    $(".tab-container").hide();
    $(".tab-container:first").show();
    $("#customer_sidebar li").click(function () {
        var e = new URLParse(window.location.href, !0);
        if ((window.history.replaceState(null, null, e.toString()), !$(this).hasClass("active"))) {
            var t = $(this).attr("id");
            if (($("#customer_sidebar li").removeClass("active"), $(this).hasClass("inactive")))
                $("#customer_sidebar li").addClass("inactive"), $(this).addClass("active"), $(this).removeClass("inactive"), $(".tab-container").hide(), $("#" + t + "C").show();
        }
    });

    $(".upbar-menu .header:not(:first)").addClass("unselected");
    $(".upbar-content .content").hide();
    $(".upbar-content .content:first").show();
    $(".upbar-menu .header").click(function () {
        if (!$(this).hasClass("selected")) {
            var e = $(this).attr("id");
            if (($(".upbar-menu .header").removeClass("selected"), $(this).hasClass("unselected")))
                $(".upbar-menu .header").addClass("unselected"), $(this).addClass("selected"), $(this).removeClass("unselected"), $(".upbar-content .content").hide(), $("#" + e + "C").show();
        }
    });

    $("[data-mask]").each(function () {
        $(this).mask($(this).attr("data-mask"));
    });

    void 0 === window.Shopify && (window.Shopify = {});
    Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    };
    Shopify.postLink = function (e, t) {
        var o = (t = t || {}).method || "post",
            r = t.parameters || {},
            a = document.createElement("form");
        for (var n in (a.setAttribute("method", o), a.setAttribute("action", e), r)) {
            var c = document.createElement("input");
            c.setAttribute("type", "hidden"), c.setAttribute("name", n), c.setAttribute("value", r[n]), a.appendChild(c);
        }
        document.body.appendChild(a), a.submit(), document.body.removeChild(a);
    };
    Shopify.CustomerAddress = {
        destroy: function (e, t) {
            Shopify.postLink("/account/addresses/" + e + "#deleted", { parameters: { _method: "delete" } });
        },
    };

    document.querySelectorAll('.video-item').forEach(item => {
        item.addEventListener('click', function(){
            const videoSrc = this.dataset.video;
            const modalSelector = "#" + this.dataset.modal;
            const modal = document.querySelector(modalSelector);
            const modalBody = modal ? modal.querySelector('.body') : null;

            if (modal && modalBody) {
                modalBody.innerHTML = `
                    <video controls autoplay playsinline>
                        <source src="${videoSrc}" type="video/mp4">
                        Seu navegador não suporta vídeo.
                    </video>
                `;
            } else {
                console.error('Modal ou .body não encontrado');
            }
        });
    });

    document.querySelectorAll('.window-modal.video .close, .window-modal.video .button-default').forEach(button => {
        button.addEventListener('click', function(){
            const modal = this.closest('.window-modal.video');
            if (modal) {
                const modalBody = modal.querySelector('.body');
                if (modalBody) {
                    modalBody.innerHTML = '';
                }
                modal.classList.remove('active');
            }
        });
    });

    document.querySelectorAll('.window-modal.video').forEach(modal => {
        modal.addEventListener('click', function(e){
            if(e.target === modal){
                const modalBody = modal.querySelector('.body');
                if (modalBody) {
                    modalBody.innerHTML = '';
                }
                modal.classList.remove('active');
            }
        });
    });

    var K = window.location.hash;
    K
        ? ($("#tab3").click(),
          K.includes("deleted") && new Noty({ type: "success", layout: "topRight", timeout: 5e3, text: "Endereço removido com sucesso!" }).show(),
          K.includes("edited") && new Noty({ type: "success", layout: "topRight", timeout: 5e3, text: "Endereço alterado com sucesso!" }).show(),
          K.includes("new") && new Noty({ type: "success", layout: "topRight", timeout: 5e3, text: "Novo endereço adicionado ao seus endereços!" }).show(),
          history.pushState("", document.title, window.location.pathname),
          history.pushState("", document.title, "/account"))
        : $("#customer_sidebar li:first").addClass("active");

    (function () {
        var body = document.body;

        if (!body || !body.classList.contains('enable-fixed-header')) return;

        var header = document.querySelector('header');
        if (!header) return;

        var scrollTrigger = 120;
        var spacer = null;
        var isFixed = false;

        function createSpacer() {
            if (spacer) return;

            spacer = document.createElement('div');
            spacer.setAttribute('data-header-spacer', 'true');
            spacer.style.width = '100%';
            spacer.style.display = 'none';

            header.parentNode.insertBefore(spacer, header.nextSibling);
        }

        function getHeaderHeight() {
            return header.offsetHeight;
        }

        function canUseFixedHeader() {
            var documentHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight
            );

            var viewportHeight = window.innerHeight;
            var headerHeight = getHeaderHeight();

            /*
            * Só ativa o header fixo quando existe
            * espaço de scroll suficiente.
            */
            return documentHeight - viewportHeight > scrollTrigger + headerHeight;
        }

        function fixHeader() {
            if (isFixed) return;

            createSpacer();

            var headerHeight = getHeaderHeight();

            spacer.style.height = headerHeight + 'px';
            spacer.style.display = 'block';

            header.classList.add('is-fixed');

            isFixed = true;
        }

        function unfixHeader() {
            if (!isFixed) return;

            header.classList.remove('is-fixed');

            if (spacer) {
                spacer.style.display = 'none';
            }

            isFixed = false;
        }

        function updateHeaderState() {
            var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                0;

            /*
            * Página pequena:
            * não deixa o header entrar no modo fixed.
            */
            if (!canUseFixedHeader()) {
                unfixHeader();
                return;
            }

            if (scrollTop > scrollTrigger) {
                fixHeader();
            } else {
                unfixHeader();
            }
        }

        updateHeaderState();

        window.addEventListener('scroll', updateHeaderState, {
            passive: true
        });

        window.addEventListener('resize', updateHeaderState);
    })();

    (function () {
        function getVariants(modal) {
            var json = modal.querySelector('[data-product-variants-json]');
            if (!json) return [];

            try {
                return JSON.parse(json.textContent);
            } catch (e) {
                console.warn('Erro variants', e);
                return [];
            }
        }

        function getSelectedOptions(modal) {
            var options = [];

            modal.querySelectorAll('.variants input[type="radio"]:checked').forEach(function (el) {
                var pos = Number(el.dataset.optionPosition);
                if (pos) options[pos - 1] = el.value;
            });

            return options;
        }

        function findVariant(variants, selected) {
            return variants.find(function (v) {
                return v.options.every(function (opt, i) {
                    return opt === selected[i];
                });
            });
        }

        function updateVariant(modal) {
            if (!modal) return;

            var variants = getVariants(modal);
            if (!variants.length) return;

            var selected = getSelectedOptions(modal);
            var variant = findVariant(variants, selected);

            if (!variant) return;

            var image = modal.querySelector('img.product-image');
            var currentSrc = image ? image.src : '';

            var newSrc = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : null;

            // ⚡ TROCA DE IMAGEM SEM DELAY
            if (image && newSrc && currentSrc !== newSrc) {
                var img = new Image();
                img.src = newSrc;

                img.onload = function () {
                    image.src = newSrc;
                };
            }

            var input = modal.querySelector('input[name="id"]');
            if (input) input.value = variant.id;

            var btn = modal.querySelector('.button-cart');
            if (btn) btn.dataset.product = variant.id;

            var imageWrapper = modal.querySelector('.image');

            selected.forEach(function (val, i) {
                var el = modal.querySelector('[data-selected-position="' + (i + 1) + '"]');
                if (el) el.textContent = val;
            });

            var single = modal.querySelector('.option-selected');
            if (single) single.textContent = variant.title;

            // selected class
            modal.querySelectorAll('.variants input').forEach(function (input) {
                var label = modal.querySelector('label[for="' + input.id + '"]');
                if (label) label.classList.toggle('selected', input.checked);
            });

            // estoque
            if (btn) {
                var isOut =
                    variant.inventory_management === 'shopify' &&
                    variant.inventory_policy !== 'continue' &&
                    variant.inventory_quantity <= 0;

                var text = btn.querySelector('.state-default');

                if (isOut) {
                    btn.disabled = true;
                    btn.classList.add('out-stock');

                    if (text) text.textContent = 'Esgotado :(';

                    if (imageWrapper) {
                        imageWrapper.classList.add('out-stock-image');
                    }

                } else {
                    btn.disabled = false;
                    btn.classList.remove('out-stock');

                    if (text) text.textContent = btn.dataset.defaultText || 'Adicionar';

                    if (imageWrapper) {
                        imageWrapper.classList.remove('out-stock-image');
                    }
                }
            }
        }

        document.addEventListener('change', function (e) {
            if (!e.target.matches('.window-modal.buy-modal .variants input')) return;

            var modal = e.target.closest('.window-modal');
            updateVariant(modal);
        });

        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-modal]');
            if (!trigger) return;

            setTimeout(function () {
                var id = trigger.dataset.modal;

                var modal = id.startsWith('#')
                    ? document.querySelector(id)
                    : document.getElementById(id);

                if (typeof updateVariant === 'function') {
                    updateVariant(modal);
                }

                if (id === 'filters') {
                    initCategoryModalSlider();
                }

            }, 250);
        });


    })();

    document.addEventListener('click', function (event) {
        var closeButton = event.target.closest('button#close');
        var modal = event.target.closest('.window-modal');

        // Botão fechar
        if (closeButton) {
            event.preventDefault();

            var currentModal = closeButton.closest('.window-modal');

            if (currentModal) {
            currentModal.classList.remove('open');
            currentModal.classList.add('close');
            }

            document.body.classList.remove('block-overflow');
            return;
        }

        // Clique fora (overlay)
        if (event.target.classList.contains('window-modal')) {
            event.target.classList.remove('open');
            event.target.classList.add('close');

            document.body.classList.remove('block-overflow');
        }
    });

    $(document).on("click", ".button-cart, .button-action", function () {
        var $this = $(this);

        // Se o botão apenas abre modal de variantes, não ativa loader
        if ($this.attr("data-has-variants") === "true" && $this.attr("data-modal")) {
            return;
        }

        if ($this.hasClass("cart-adding")) return;

        $this
            .attr("disabled", "disabled")
            .css("pointer-events", "none")
            .addClass("cart-adding");

        setTimeout(function () {
            $this.removeClass("cart-adding")
                .removeAttr("disabled")
                .css("pointer-events", "");
        }, 5000);
    });

    if (typeof formatReviewNumbers === 'function') {
        formatReviewNumbers();

        var tries = 0;

        var interval = setInterval(function () {
            formatReviewNumbers();
            tries++;

            if (tries >= 30) {
                clearInterval(interval);
            }
        }, 1000);
    }

    // Wishlist
    (function () {
        if (!window.FavoritesSystem) return;

        function getProductHandle(card) {
            var link = card.querySelector('a[href*="/products/"]');
            if (!link) return '';

            return FavoritesSystem.sanitizeHandle(link.getAttribute('href'));
        }

        function getButtonProductHandle(button) {
            var buttonHandle = button.getAttribute('data-product-handle');

            if (buttonHandle) {
                return FavoritesSystem.sanitizeHandle(buttonHandle);
            }

            var card = button.closest('.single-product');

            if (card) {
                return getProductHandle(card);
            }

            var isMainProductButton =
                button.closest('.product-single') &&
                !button.closest('.product-recommendations') &&
                !button.closest('.product-upsell') &&
                !button.closest('.swiper-slide') &&
                !button.closest('.single-product');

            if (isMainProductButton) {
                return FavoritesSystem.sanitizeHandle(window.location.pathname);
            }

            return '';
        }

        function updateFavoritesCounter() {
            var count = FavoritesSystem.getItems().length;

            document.querySelectorAll('[data-favorites-counter], .wishlist-count').forEach(function (el) {
                el.textContent = count;
                el.classList.toggle('product-added', count > 0);
            });

            var titleCounter = document.querySelector('[data-favorites-title-counter]');
            if (titleCounter) titleCounter.textContent = count;
        }

        function updateFavoriteButtons() {
            document.querySelectorAll('.wishlist-toggle').forEach(function (button) {
                var handle = getButtonProductHandle(button);

                button.classList.remove('active');

                if (!handle) {
                    button.classList.remove('favorited');
                    return;
                }

                button.dataset.productHandle = handle;

                var isFavorited = FavoritesSystem.has(handle);

                if (!button.classList.contains('removed')) {
                    if (isFavorited) {
                        button.classList.add('favorited');
                    } else {
                        button.classList.remove('favorited');
                    }
                }

                button.setAttribute(
                    'aria-label',
                    isFavorited ? 'Remover dos favoritos' : 'Adicionar aos favoritos'
                );
            });

            updateFavoritesCounter();
        }

        function injectFavoriteButtons() {
            document.querySelectorAll('.wishlist-toggle').forEach(function (button) {
                var handle = getButtonProductHandle(button);

                if (!handle) return;

                button.dataset.productHandle = handle;
            });

            updateFavoriteButtons();
        }

        function renderFavoriteCard(product) {
            var image = product.featured_image || '';
            var price = product.price;
            var compareAtPrice = product.compare_at_price;
            var moneyFormat = document.body.getAttribute('data-money-format');

            var priceHtml = '';

            if (compareAtPrice && compareAtPrice > price) {
                priceHtml += '<div class="compare-price">' + formatMoney(compareAtPrice, moneyFormat) + '</div>';
            }

            priceHtml += '<div class="sale-price">' + formatMoney(price, moneyFormat) + '</div>';

            return `
                <div class="single-product favorite-product" data-product="${product.id}">
                    <div class="image">
                        <a href="${product.url}">
                            <img src="${image}" alt="${product.title}" loading="lazy">
                        </a>

                        <button type="button" class="button-wishlist wishlist-toggle active" data-product-handle="${product.handle}" aria-label="Remover dos favoritos">
                            <i class="far fa-heart"></i>
                            <i class="fas fa-heart"></i>
                        </button>
                    </div>

                    <div class="info">
                        <h3><a href="${product.url}">${product.title}</a></h3>

                        <div class="price">
                            ${priceHtml}
                        </div>

                        <button type="button" class="button-default remove-favorite" data-remove-favorite="${product.handle}">
                            Remover dos favoritos
                        </button>
                    </div>
                </div>
            `;
        }

        function renderFavoritesPage() {
            var page = document.querySelector('[data-favorites-page]');
            if (!page) return;

            var list = page.querySelector('[data-favorites-list]');
            var empty = page.querySelector('[data-favorites-empty]');
            var info = page.querySelector('[data-favorites-info]');
            var titleCounter = page.querySelector('[data-favorites-title-counter]');

            if (!list || !empty) return;

            var handles = FavoritesSystem.getItems();

            var visibleCount = 0;

            page.querySelectorAll('[data-favorite-product-handle]').forEach(function (item) {
                var handle = item.dataset.favoriteProductHandle;
                var isFavorite = handles.indexOf(handle) > -1;

                item.classList.toggle('hide', !isFavorite);

                if (isFavorite) {
                    visibleCount++;
                }
            });

            if (titleCounter) {
                titleCounter.textContent = visibleCount;
            }

            if (visibleCount > 0) {
                empty.classList.add('hide');

                if (info) {
                    info.classList.remove('hide');
                }

                list.classList.remove('hide');
            } else {
                empty.classList.remove('hide');

                if (info) {
                    info.classList.add('hide');
                }

                list.classList.add('hide');
            }

            updateFavoritesCounter();
            updateFavoriteButtons();
        }

        document.addEventListener('click', function (event) {
            var button = event.target.closest('.wishlist-toggle');

            if (button) {
                event.preventDefault();
                event.stopPropagation();

                var handle = getButtonProductHandle(button);
                if (!handle) return;

                button.dataset.productHandle = handle;

                var isFavorited = FavoritesSystem.has(handle);

                button.classList.remove('active', 'removed');

                void button.offsetWidth;

                if (isFavorited) {
                    button.classList.remove('favorited');
                    button.classList.add('removed');

                    void button.offsetWidth;

                    FavoritesSystem.remove(handle);

                    setTimeout(function () {
                        button.classList.remove('removed', 'active');
                        updateFavoriteButtons();
                        renderFavoritesPage();
                    }, 220);
                } else {
                    button.classList.add('active');

                    FavoritesSystem.add(handle);

                    setTimeout(function () {
                        button.classList.remove('active');
                        button.classList.add('favorited');

                        updateFavoriteButtons();
                        renderFavoritesPage();
                    }, 220);
                }

                return;
            }

            var removeButton = event.target.closest('[data-remove-favorite]');

            if (removeButton) {
                event.preventDefault();

                FavoritesSystem.remove(removeButton.dataset.removeFavorite);

                updateFavoriteButtons();
                renderFavoritesPage();
            }
        });

        injectFavoriteButtons();
        renderFavoritesPage();

        document.addEventListener('shopify:section:load', function () {
            injectFavoriteButtons();
            renderFavoritesPage();
        });

        window.initFavoritesSystem = function () {
            injectFavoriteButtons();
            renderFavoritesPage();
        };
    })();
});

(function () {
    var mainSwiper = null;
    var thumbsSwiper = null;
    var lastWindowWidth = window.innerWidth;
    var lastIsMobile = window.matchMedia('(max-width: 767px)').matches;

    function updateGalleryCounter(swiper, counterEl) {
        if (!swiper || !counterEl) return;

        var current = swiper.realIndex + 1;
        var total = swiper.slides.length;

        counterEl.textContent = current + '/' + total;
        counterEl.classList.add('ready');
    }

    function updateNavigationVisibility(swiper, prevBtn, nextBtn) {
        if (!swiper || !prevBtn || !nextBtn) return;

        var isBeginning = swiper.isBeginning;
        var isEnd = swiper.isEnd;

        prevBtn.style.display = isBeginning ? 'none' : 'flex';
        nextBtn.style.display = isEnd ? 'none' : 'flex';
    }

    function applySoldOutStateToGallery(gallery) {
        if (!gallery || !window.productSoldOutImagePositions || !window.productSoldOutImagePositions.length) return;

        var soldOutPositions = window.productSoldOutImagePositions;

        var mainSlides = gallery.querySelectorAll('.product-gallery-main .swiper-slide');
        var thumbSlides = gallery.querySelectorAll('.product-gallery-thumbs .swiper-slide');

        mainSlides.forEach(function (slide, index) {
        slide.classList.toggle('is-sold-out', soldOutPositions.indexOf(index + 1) > -1);
        });

        thumbSlides.forEach(function (slide, index) {
        slide.classList.toggle('is-sold-out', soldOutPositions.indexOf(index + 1) > -1);
        });
    }

    function refreshSoldOutState() {
        var gallery = document.querySelector('.product-gallery');
        if (!gallery) return;
        applySoldOutStateToGallery(gallery);
    }

    function getDesiredInitialSlide() {
        if (
        window.shouldUseVariantInitialSlide === true &&
        typeof window.productVariantSlideIndex === 'number' &&
        window.productVariantSlideIndex >= 0
        ) {
        return window.productVariantSlideIndex;
        }

        return 0;
    }

    function getSafeActiveSlide() {
        if (typeof window.productVariantSlideIndex === 'number' && window.productVariantSlideIndex >= 0) {
        return window.productVariantSlideIndex;
        }

        if (mainSwiper) {
        return mainSwiper.realIndex || 0;
        }

        return 0;
    }

    function shouldLockVariantSlide() {
        return (
        typeof window.productVariantSlideIndex === 'number' &&
        window.productVariantSlideIndex >= 0 &&
        typeof window.lockVariantSlideUntil === 'number' &&
        Date.now() < window.lockVariantSlideUntil
        );
    }

    function forceVariantSlide(swiper) {
        if (!swiper) return;
        if (!shouldLockVariantSlide()) return;

        if (swiper.activeIndex !== window.productVariantSlideIndex) {
        swiper.slideTo(window.productVariantSlideIndex, 0);
        }
    }

    function initProductGallery() {
        var gallery = document.querySelector('.product-gallery');
        if (!gallery) return;

        var thumbsEl = gallery.querySelector('.product-gallery-thumbs');
        var mainEl = gallery.querySelector('.product-gallery-main');
        var paginationEl = gallery.querySelector('.product-gallery__pagination');
        var counterEl = gallery.querySelector('.product-gallery__counter');
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var prevBtn = gallery.querySelector('.product-gallery__nav .prev');
        var nextBtn = gallery.querySelector('.product-gallery__nav .next');

        var initialSlide = mainSwiper ? getSafeActiveSlide() : getDesiredInitialSlide();

        if (thumbsSwiper) {
        thumbsSwiper.destroy(true, true);
        thumbsSwiper = null;
        }

        if (mainSwiper) {
        mainSwiper.destroy(true, true);
        mainSwiper = null;
        }

        if (!isMobile && thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 10,
            watchSlidesProgress: true,
            freeMode: true
        });
        }

        var config = {
        initialSlide: initialSlide,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 350,
        threshold: 8,
        touchRatio: 1.2,
        shortSwipes: true,
        longSwipesRatio: 0.15,
        nested: true,
        touchAngle: 45,
        touchStartPreventDefault: true,
        touchMoveStopPropagation: true,
        resistanceRatio: 0.85,
        preloadImages: false,
        updateOnImagesReady: true,
        observer: true,
        observeParents: true,
        noSwiping: true,
        noSwipingSelector: 'video, iframe, .swiper-no-swiping',
        on: {
            init: function () {
            forceVariantSlide(this);
            updateGalleryCounter(this, counterEl);
            updateNavigationVisibility(this, prevBtn, nextBtn);

            setTimeout(() => {
                forceVariantSlide(this);
                updateGalleryCounter(this, counterEl);
                updateNavigationVisibility(this, prevBtn, nextBtn);
            }, 80);

            setTimeout(() => {
                forceVariantSlide(this);
                updateGalleryCounter(this, counterEl);
                updateNavigationVisibility(this, prevBtn, nextBtn);
            }, 250);
            },
            slideChange: function () {
            updateGalleryCounter(this, counterEl);
            updateNavigationVisibility(this, prevBtn, nextBtn);
            },
            touchStart: function () {
            window.lockVariantSlideUntil = 0;
            }
        }
        };

        if (!isMobile && prevBtn && nextBtn) {
        config.navigation = {
            prevEl: prevBtn,
            nextEl: nextBtn
        };
        }

        if (!isMobile && thumbsSwiper) {
        config.thumbs = {
            swiper: thumbsSwiper
        };
        } else {
        config.pagination = {
            el: paginationEl,
            clickable: true
        };
        }

        mainSwiper = new Swiper(mainEl, config);
        mainEl.swiper = mainSwiper;

        applySoldOutStateToGallery(gallery);

        lastWindowWidth = window.innerWidth;
        lastIsMobile = isMobile;
        window.shouldUseVariantInitialSlide = false;
    }

    function handleGalleryResize() {
        var currentWidth = window.innerWidth;
        var currentIsMobile = window.matchMedia('(max-width: 767px)').matches;

        var widthChanged = currentWidth !== lastWindowWidth;
        var breakpointChanged = currentIsMobile !== lastIsMobile;

        if (!widthChanged && !breakpointChanged) {
        return;
        }

        clearTimeout(window.__galleryResizeTimer);
        window.__galleryResizeTimer = setTimeout(function () {
        initProductGallery();
        }, 200);
    }

    document.addEventListener('DOMContentLoaded', initProductGallery);
    window.addEventListener('resize', handleGalleryResize);
})();

(function () {
    // showCart & showMiniCart
    var currentPage = window.location.pathname;
    var urlParams = new URLSearchParams(window.location.search);

    // --- showCart ---
    if (urlParams.has("showCart")) {
        let showCartValue = urlParams.get("showCart").trim();
        localStorage.setItem("showCart", showCartValue || "false");
    } else if (localStorage.getItem("showCart") == null) {
        localStorage.setItem("showCart", "false");
    }

    // --- showMiniCart ---
    if (urlParams.has("showMiniCart")) {
        let showMiniCartValue = urlParams.get("showMiniCart").trim();
        localStorage.setItem("showMiniCart", showMiniCartValue || "false");
    } else if (localStorage.getItem("showMiniCart") == null) {
        localStorage.setItem("showMiniCart", "false");
    }
})();